const isBrowser: boolean = globalThis.location !== undefined;

interface Price {
  amount?: number;
}

interface Variant {
  shopifyId?: string;
  sku?: string;
  title?: string;
  price?: Price | number;
}

interface Product {
  shopifyId?: string;
  title?: string;
  productType?: string;
  vendor?: string;
}

interface Item {
  quantity?: number;
  variant: Variant;
  product: Product;
  category?: string;
  isSubscription?: boolean;
}

interface PushOptions {
  event: string;
  ecommerce?: any;
  items?: any[];
  [key: string]: any;
}

function isPriceObject(price: Price | number): price is Price {
  return typeof price === 'object' && price !== null;
}

const variantToGaItem = ({
  quantity = 1,
  variant,
  product,
  category,
  isSubscription,
}: Item) => {
  const data: any = {
    product_gid: product?.shopifyId?.replace('gid://shopify/Product/', ''),
    variant_gid: variant?.shopifyId?.replace(
      'gid://shopify/ProductVariant/',
      ''
    ),
    item_id: variant?.sku,
    item_name: product?.title,
    item_category: product?.productType,
    item_brand: product?.vendor,
    item_variant: variant?.title?.replace('Default Title', ''),
    price: isPriceObject(variant?.price)
      ? variant.price.amount
      : variant?.price,
    quantity,
    affiliation: 'Gatsby DTC Store',
    isSubscription: !!isSubscription,
  };

  // mutate data item_categoryX if they have category string `/shop/dog/doors` or default to using productType if available
  if (category) {
    category
      ?.split('/')
      .filter(n => n)
      .slice(0, 5)
      .forEach((cat, i) => {
        if (i === 0) {
          data.item_category = cat?.toLowerCase();
        } else {
          data[`item_category${i}`] = cat?.toLowerCase();
        }
      });
  } else if (product?.productType) {
    data.item_category = product?.productType.toLowerCase();
  }

  return data;
};

const mapItem = (item: any) => variantToGaItem(item);

export function pushToDataLayer(data: PushOptions) {
  if (!isBrowser) return;
  // GA4 add_to_cart https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm
  globalThis.dataLayer = globalThis.dataLayer || [];

  const { event, ecommerce, items, ...rest } = data;

  if (ecommerce && Array.isArray(items)) {
    globalThis.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

    globalThis.dataLayer.push({
      event,
      ecommerce: {
        ...ecommerce,
        items: items.map(mapItem),
      },
      ...rest,
    });

    return;
  }

  globalThis.dataLayer.push({
    event,
    ...rest,
  });
}

export default pushToDataLayer;
